import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'client-sign-stock-warning',
  templateUrl: './client-sign-stock-warning.component.html',
  styleUrls: ['./client-sign-stock-warning.component.scss']
})
export class ClientSignStockWarningComponent {
  @Output()
  intendOrderStock = new EventEmitter<boolean>();

  orderStock(): void {
    this.intendOrderStock.emit(true);
  }

  close(): void {
    this.intendOrderStock.emit(false);
  }
}
